var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5955",
    "data-name": "Group 5955",
    transform: "translate(-1192.5 -245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1960",
    "data-name": "Rectangle 1960",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(1192.5 245)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "marker_6_",
    "data-name": "marker (6)",
    d: "M11.168.042A9.159,9.159,0,0,0,2.019,9.19c0,2.356,1.824,6.043,5.422,10.958a4.614,4.614,0,0,0,7.454,0c3.6-4.915,5.422-8.6,5.422-10.958A9.159,9.159,0,0,0,11.168.042Zm0,12.795A3.667,3.667,0,1,1,14.835,9.17,3.667,3.667,0,0,1,11.168,12.837Z",
    transform: "translate(1206.332 258.958)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationProfile);
export default __webpack_public_path__ + "static/media/location_profile.de81d04428fe16a284de7d989559aad8.svg";
export { ForwardRef as ReactComponent };